// Generated from SVG to Code Figma Plugin

export const AudioPauseIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 48 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12C48 18.6274 42.6274 24 36 24H12C5.37258 24 0 18.6274 0 12Z"
      fill="currentColor"
      fillOpacity="0.24"
    />
    <path d="M21.625 9V15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
    <path d="M26.375 9V15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
  </svg>
);
